<template lang="pug">
  .columns.box-more.mt-2
    .column.box-more-label {{ label }}
    .column.col-auto.box-more-value {{ value }}
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
  },
}
</script>

<style lang="stylus" scoped>
.box-more
  font-size .7rem

  .box-more-value
    font-size .7rem
    font-weight bold
</style>
